// src/components/LinksManagerDragHandle.js
import React from "react";
import { GripVertical, Crown } from "lucide-react";
import styles from "./LinksManager.module.css";

// DragHandle component used in both pro and free branches
const LinksManagerDragHandle = ({
  isProUser,
  onUpgradeClick,
  dragHandleProps,
  isDragging,
  showBadge,
}) => {
  if (isProUser) {
    return (
      <div
        {...dragHandleProps}
        className={`${styles.dragHandle} ${
          isDragging ? styles.draggingHandle : ""
        }`}
      >
        <GripVertical size={18} />
      </div>
    );
  } else {
    return (
      <div onClick={onUpgradeClick} className={styles.dragHandleDisabled}>
        <GripVertical size={18} />
        {showBadge && <Crown size={16} className={styles.crownIcon} />}
      </div>
    );
  }
};

export default LinksManagerDragHandle;